import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Text } from '@chakra-ui/react';
import { CCUI_LOCALE_COOKIE } from '@whitbread-eos/api';
import { formatNextLocaleLink } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { formatDataTestId } from '../../utils/formatters';
import Popover from '../Popover';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export default function LanguageSelector(_ref) {
  var _ref$currentLanguage = _ref.currentLanguage,
    currentLanguage = _ref$currentLanguage === void 0 ? '' : _ref$currentLanguage,
    prefixDataTestId = _ref.prefixDataTestId,
    tickIcon = _ref.tickIcon,
    languagesList = _ref.languagesList,
    area = _ref.area;
  var baseTestId = formatDataTestId(prefixDataTestId, 'languageSelectorContainer');
  var router = useRouter();
  var path = router === null || router === void 0 ? void 0 : router.asPath;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  return _jsx(Flex, {
    justifyContent: "flex-end",
    mr: {
      lg: '2.125rem ',
      xl: '1.875rem'
    },
    "data-testid": baseTestId,
    children: _jsx(Popover, {
      triggerItem: renderFlag(currentLanguage),
      styles: {
        arrowStyles: popoverArrowStyles
      },
      children: _jsx(Flex, _objectSpread(_objectSpread({}, childrenWrapperStyle), {}, {
        cursor: "pointer",
        children: languagesList.map((language, index) => {
          var link = formatNextLocaleLink(path, language.locale, currentLanguage, area);
          return _createElement(Flex, _objectSpread(_objectSpread({}, childrenContainerStyle(index, languagesList.length - 1)), {}, {
            key: language.locale,
            onClick: () => {
              document.cookie = "".concat(CCUI_LOCALE_COOKIE, "=").concat(language.locale === 'de' ? 'de' : 'gb', "; max-age=31536000; path=/");
              window.location = link;
            }
          }), _jsxs(Flex, {
            children: [renderFlag(language.locale), _jsx(Text, {
              color: "darkGrey1",
              ml: "sm",
              fontWeight: currentLanguage === language.locale ? 'medium' : '',
              children: t(language.languageName)
            })]
          }), currentLanguage === language.locale && tickIcon);
        })
      }))
    })
  });
  function renderFlag(language) {
    var country = languagesList.find(languageObject => languageObject.locale == language);
    if (country) {
      return country.icon;
    }
  }
}
var popoverArrowStyles = {
  boxShadow: '-2px 2px 1px 0 var(--chakra-colors-lightGrey4) !important',
  width: '140% !important;',
  height: '143% !important;',
  top: '-2.5px !important;',
  left: '-1px !important;'
};
var childrenWrapperStyle = {
  flexDir: 'column',
  justifyContent: 'center',
  w: '11.375rem'
};
var childrenContainerStyle = (index, listLength) => {
  return {
    h: 'var(--chakra-space-lg)',
    mb: index != listLength && 'var(--chakra-space-md)',
    justifyContent: 'space-between',
    _hover: {
      p: {
        textDecoration: 'underline'
      }
    }
  };
};